"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MailFill_exports = {};
__export(MailFill_exports, {
  default: () => MailFill_default
});
module.exports = __toCommonJS(MailFill_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.95703 4.58594C3.68359 4.58594 3.44922 4.68359 3.25391 4.87891C3.05859 5.07422 2.96094 5.30859 2.96094 5.58203V5.97266L10.1875 10.4844C10.2786 10.5495 10.3763 10.582 10.4805 10.582C10.5977 10.582 10.7018 10.5495 10.793 10.4844L18.0195 5.97266V5.58203C18.0195 5.30859 17.9219 5.07422 17.7266 4.87891C17.5312 4.68359 17.2969 4.58594 17.0234 4.58594H3.95703ZM18.0195 6.94922L11.2422 11.1875C11.0078 11.3438 10.7539 11.4219 10.4805 11.4219C10.2201 11.4219 9.97266 11.3438 9.73828 11.1875L2.96094 6.94922V14.8789C2.96094 15.1523 3.05859 15.3867 3.25391 15.582C3.44922 15.7773 3.68359 15.875 3.95703 15.875H17.0234C17.2969 15.875 17.5312 15.7773 17.7266 15.582C17.9219 15.3867 18.0195 15.1523 18.0195 14.8789V6.94922ZM3.95703 4.58594C3.68359 4.58594 3.44922 4.68359 3.25391 4.87891C3.05859 5.07422 2.96094 5.30859 2.96094 5.58203V5.97266L10.1875 10.4844C10.2786 10.5495 10.3763 10.582 10.4805 10.582C10.5977 10.582 10.7018 10.5495 10.793 10.4844L18.0195 5.97266V5.58203C18.0195 5.30859 17.9219 5.07422 17.7266 4.87891C17.5312 4.68359 17.2969 4.58594 17.0234 4.58594H3.95703ZM18.0195 6.94922L11.2422 11.1875C11.0078 11.3438 10.7539 11.4219 10.4805 11.4219C10.2201 11.4219 9.97266 11.3438 9.73828 11.1875L2.96094 6.94922V14.8789C2.96094 15.1523 3.05859 15.3867 3.25391 15.582C3.44922 15.7773 3.68359 15.875 3.95703 15.875H17.0234C17.2969 15.875 17.5312 15.7773 17.7266 15.582C17.9219 15.3867 18.0195 15.1523 18.0195 14.8789V6.94922Z",
      fill: "currentColor"
    }
  )
);
const SvgMailFill = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MailFill_default = SvgMailFill;
